export default "__VITE_ASSET__f8894cef__$_?react__"